import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <h2 className="section-title">
          <span className="gold-text">Why $GOLD?</span>
        </h2>

        <div className="about-content">
          <div className="about-main">
            <div className="about-text">
              <h3>The Ultimate Store of Value, Now on Ethereum</h3>
              <p>
                For 5,000 years, gold has been humanity's most trusted store of value. 
                Empires rise and fall, currencies inflate away, but gold endures. Now, 
                we're bringing that timeless value to the Ethereum blockchain.
              </p>
              <p>
                <span className="gold-text">$GOLD</span> isn't just another meme coin – it's a 
                movement. It represents the awakening of a generation that sees through the 
                fiat illusion and understands why central banks are <strong>hoarding gold 
                at record levels</strong>.
              </p>
              <p>
                While Bitcoin maximalists argue and altcoins pump and dump, gold quietly 
                marches to new all-time highs. <span className="gold-text">Gold is eating 
                everything</span> – stocks, bonds, real estate, and yes, even crypto.
              </p>
            </div>

            <div className="about-features">
              <div className="feature">
                <span className="feature-icon">🛡️</span>
                <div className="feature-content">
                  <h4>Inflation Hedge</h4>
                  <p>Gold has protected wealth through every monetary crisis in history</p>
                </div>
              </div>
              <div className="feature">
                <span className="feature-icon">🏛️</span>
                <div className="feature-content">
                  <h4>Central Bank Approved</h4>
                  <p>Over 1,000 tons bought by central banks in 2024 alone</p>
                </div>
              </div>
              <div className="feature">
                <span className="feature-icon">🌍</span>
                <div className="feature-content">
                  <h4>Global De-dollarization</h4>
                  <p>BRICS nations leading the charge back to gold-backed systems</p>
                </div>
              </div>
              <div className="feature">
                <span className="feature-icon">📉</span>
                <div className="feature-content">
                  <h4>Fiat is Failing</h4>
                  <p>Every fiat currency in history has eventually gone to zero</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-quote">
            <blockquote>
              <p>"Gold is money. Everything else is credit."</p>
              <cite>— J.P. Morgan, 1912</cite>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
